import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Agency } from '../models/agency.model';
import { AccountInfo } from '../models/account-info.model';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly accountUrl = environment.apiUrl + '/v1.5/agent/account';

  constructor(private http: HttpClient) {}

  getAccountInfo(): Observable<AccountInfo> {
    const url = `${this.accountUrl}/info`;

    return this.http
      .get<{ status: string; message: string; data: AccountInfo }>(url)
      .pipe(map(response => response.data));
  }

  getAgencies(): Observable<Agency[]> {
    const url = `${this.accountUrl}/agencies`;

    return this.http
      .get<{ status: string; data: Agency[] }>(url)
      .pipe(map(response => response.data));
  }
}
